import Label from "lib/Label";
import React from "react";
import "./index.scss";
import ErrorMessage from "lib/ErrorMessage";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import {  setSelectedData } from "redux/formDisplay";
import { getAllUsersByOrg} from  "api/dashboard"
import Dropdown from 'react-bootstrap/Dropdown';


const SearchableDropdown = (props) => {
  var {
    options_type,
    label,
    web_grid_col,
    mobile_grid_col,
    onChange,
    placeholder,
    name,
    value: userValue,
    class_name,
    togglecopy,
    togglesublable,
    error,
    copyToClipboard,
    selectedData,
    setSelectedData,
    size,
    isEditable,
    is_disabled,
    validators,
    events,
    name,
    user_id_list,
    role_id_list,
    clearFieldError,
    show
  } = props;   
  const formData = useSelector((state) => state.formData.selectedData);    
  const dispatch = useDispatch();
  const status = useSelector((state) => state.staticData?.status);
  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";
  const isToggled = useSelector((state) => state.formData.isToggled);

  const loggedInUserInfo = useSelector((state) => state.loggedInUserInfo?.userAuthInfo)
  let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
 

  const IndirectEval = (evalString) =>{
    return eval(evalString)
  }
  const onClick=async (item)=>{
    if(events){
     IndirectEval(events?.onClick)
    }
  }
  
  const [searchTerm, setSearchTerm] = useState("");
  const [options, setOptions] = useState([]);

  const [filteredOptions, setFilteredOptions] = useState();
  const [selectedOption, setSelectedOption] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [data, setData] = useState(null);
  const [defaultValue, setDefaultValue] = useState();
  useEffect(() => {
    !selectedData[name] && setDefaultValue("Select");
  }, []);
    

useEffect(() => {
  const getUser = async () => {
      try {
        const response = await dispatch(
          getAllUsersByOrg({ id: loggedInUserInfo?.organisationInfo?._id || formData?.organisation_id  })
        );
        const fetchedData = response.payload;

        let updatedOptions = [];
        if (options_type === "all_users") {
          updatedOptions = fetchedData?.map((user) => ({
            label: `${user?.profile?.first_name} ${user?.profile?.last_name}`,
            value: user._id,
          }));
        } else if (options_type === "list_users") {
          updatedOptions = fetchedData?.filter((user) =>
            user_id_list.includes(user._id)
          ).map((user) => ({
            label: `${user?.profile?.first_name} ${user?.profile?.last_name}`,
            value: user._id,
          }));
        }else if (options_type === "list_roles") {
          updatedOptions = fetchedData?.filter((user) =>
            role_id_list.includes(user.role)
          ).map((user) => ({
            label: `${user?.profile?.first_name} ${user?.profile?.last_name}`,
            value: user._id,
          }));
        }

        setOptions(updatedOptions);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
  };
  getUser();
}, [options_type, dispatch, loggedInUserInfo, user_id_list,role_id_list]);


useEffect(() => {
  if (searchTerm) {
    setFilteredOptions(
      options?.filter((option) =>
        option?.label.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  } else {
    setFilteredOptions(options);
  }
}, [searchTerm, options]);



  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const handleSearch = (e) => {    
    setSearchTerm(e.target.value);
    clearFieldError(name);
  };

  const handleOptionClick = (option,data) => {
    setSelectedOption(option);
    setIsDropdownOpen(false); 
    clearFieldError(name);
    dispatch(setSelectedData({ key: name, value: data }));
  };

  if(!show) return null;
  return (
    <>
      <Label
        label={label}
        togglecopy={togglecopy}
        togglesublabel={togglesublable}
        copyToClipboard={copyToClipboard}
        selectedData={selectedData}
        setSelectedData={setSelectedData}
        validators={validators}
      />

      <Dropdown>
        <Dropdown.Toggle
          id="dropdown-basic"
          className="w-100 bg-white border text-dark d-flex justify-content-between shadow-none"
        >
          <span>{selectedOption ? selectedOption.label : "Select"}</span>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-caret-down-fill"
              viewBox="0 0 16 16"
            >
              <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
            </svg>
          </span>
        </Dropdown.Toggle>

        <Dropdown.Menu className="w-95">
          <div className="dropdown-search">
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearch}
              placeholder={placeholder || "Search...."}
              // className="p-2 outline-0 border-0 border-bottom rounded-0"
              className="outline-0"
              disabled={
                eval(is_disabled)
                  ? true
                  : !isEditable ||
                    (isToggled &&
                      ((userValue?.label && userValue?.label?.length) ||
                        selectedData[name]?.length))
              }
            />
          </div>
          <div className="max-h-100px overflow-hover-scroll theme-scrollbar">
            {filteredOptions?.length > 0 ? (
              filteredOptions.map((option, index) => (
                <Dropdown.Item
                  key={index}
                  value={option.value}
                  className="dropdown-option"
                  onClick={
                    () => handleOptionClick(option, option.label)
                    // setIsDropdownOpen(false);
                  }
                >
                  <span className="option-label">{option.label}</span>
                </Dropdown.Item>
              ))
            ) : (
              <div className="d-flex justify-content-center align-items-center">
                <Label
                  label="No Data Found"
                  className="d-flex justify-content-center"
                />
              </div>
            )}
          </div>
        </Dropdown.Menu>
      </Dropdown>
      <div>{error?.length !== 0 && <ErrorMessage error={error} />}</div>
    </>
  );
};

export default SearchableDropdown;
